export function canAnimateSearchTransition(): boolean {
  return (
    typeof document.startViewTransition === "function" &&
    "activeViewTransition" in document &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export function optimizeSearchTransition() {
  const transition = document.activeViewTransition;
  if (!transition) return;

  void transition.ready
    .then(
      () => {
        const effect = document
          .getAnimations()
          .map((animation) => animation.effect)
          .find(
            (effect): effect is KeyframeEffect =>
              effect instanceof KeyframeEffect &&
              effect.pseudoElement === "::view-transition-group(search-bar)",
          );
        if (!effect) return;

        const frames = effect.getKeyframes();
        const first = frames[0];
        const last = frames.at(-1);
        if (!first || !last) return;

        const width = Number.parseFloat(String(last.width));
        const height = Number.parseFloat(String(last.height));
        const scaleX = Number.parseFloat(String(first.width)) / width;
        const scaleY = Number.parseFloat(String(first.height)) / height;
        if (
          ![width, height, scaleX, scaleY].every((value) => Number.isFinite(value) && value > 0)
        ) {
          throw new Error("Search transition captured invalid dimensions.");
        }

        // Keep the group's final size and scale its snapshot instead of animating dimensions.
        const from = new DOMMatrix(String(first.transform)).scale(scaleX, scaleY);
        effect.setKeyframes([
          { transform: from.toString(), easing: first.easing },
          { transform: String(last.transform), easing: last.easing },
        ]);
      },
      // Native transitions can be skipped; the router owns update-callback failures.
      () => undefined,
    )
    .catch((cause: unknown) => {
      reportError(new Error("Unable to animate the search transition.", { cause }));
    });
}
